module.exports = __webpack_public_path__ + "img/workflow_8.d6c68c14.jpg";